import { withIcon } from "../Icon"

export const IconSearch = withIcon(
  '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="m20 20-3.778-3.784m2.094-5.058a7.158 7.158 0 1 1-14.316 0 7.158 7.158 0 0 1 14.316 0v0Z"/>',
)
